// Utilidades para las filas que maneja app-table-ultimate (ng-components-tsi).
//
// La tabla trabaja con COPIAS de las filas a las que agrega `idListTsi` (id de
// fila) y `_format` (valores formateados). Si la fila no trae `idListTsi`, la
// tabla genera un UUID nuevo cada vez que cambian las filas o columnas, así que
// la selección de checkboxes se pierde visualmente pero sigue guardada.

/** Campos que agrega app-table-ultimate a las filas; nunca deben ir al backend. */
export const CAMPOS_FILA_TABLA = ['idListTsi', '_format'] as const

/**
 * Asigna a cada fila un `idListTsi` estable a partir de sus claves, para que la
 * selección (`selectItems`) sobreviva a recargas o a cambiar de vista.
 */
export function conIdFila<T extends object>(rows: T[], keys: (keyof T & string)[]): T[] {
  const usados = new Set<string>()
  return (rows ?? []).map((row, index) => {
    const valores = keys.map(k => row?.[k])
    let id = valores.join('|')
    // Si falta la clave o se repite, varias filas compartirían id y marcar una
    // las marcaría todas: en ese caso se desambigua con el índice.
    if (valores.every(v => v == null || v === '') || usados.has(id)) id = `${id}#${index}`
    usados.add(id)
    return { ...row, idListTsi: id }
  })
}

/** Quita (en profundidad) los campos internos de la tabla de un body a enviar. */
export function limpiarFilaTabla<T>(valor: T): T {
  if (Array.isArray(valor)) return valor.map(item => limpiarFilaTabla(item)) as T
  if (!esObjetoPlano(valor)) return valor
  const limpio: Record<string, unknown> = {}
  for (const [clave, dato] of Object.entries(valor as Record<string, unknown>)) {
    if ((CAMPOS_FILA_TABLA as readonly string[]).includes(clave)) continue
    limpio[clave] = limpiarFilaTabla(dato)
  }
  return limpio as T
}

function esObjetoPlano(valor: unknown): valor is object {
  if (valor === null || typeof valor !== 'object') return false
  const proto = Object.getPrototypeOf(valor)
  return proto === Object.prototype || proto === null
}
